const doc = [({"da":({"js":({"feedback_steps":({"dropdown":({"choose_one_of_the_options":"Vælg én af mulighederne"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;